export default {
  Register: 'Register',
  'Full name': 'Full name',
  'Confirm Password': 'Confirm Password',
  'I want to process this payment without enhanced authentication (verification code sent to the card owner) and I consent that I am responsible for this payment.':
    'I want to process this payment without enhanced authentication (verification code sent to the card owner) and I consent that I am responsible for this payment.',
  Download: 'Download',
  'Only missing HCN': 'Only missing HCN',
  'Filter Reservations By': 'Filter Reservations By',
  'Filter Vouchers By': 'Filter Vouchers By',
  'Advanced search': 'Advanced search',
  'Close advanced search': 'Close advanced search',
  'Reservation id': 'Reservation id',
  'Supplier name': 'Supplier name',
  'Filter date by': 'Filter date by',
  'Check-in date': 'Check-in date',
  'Creation date': 'Creation date',
  Till: 'Till-',
  'Customer name': 'Customer name',
  'Customer phone': 'Customer phone',
  'Customer email': 'Customer email',
  'Agent id': 'Agent id',
  'Supplier booking id': 'Supplier booking id',
  'Set hotel confirmation number': 'Set hotel confirmation number',
  'Enter hotel confirmation number': 'Enter hotel confirmation number',
  'Hotel confirmation number': 'Hotel confirmation number',
  'Supplier confirmation number': 'Supplier confirmation number',
  'All Reservations': 'All Reservations',
  Supplier: 'Supplier',
  Cancun: 'Cancun',
  Barcelona: 'Barcelona',
  Amsterdam: 'Amsterdam',
  Berlin: 'Berlin',
  Dubai: 'Dubai',
  Travelor: 'Travelor',
  Navigation: 'Navigation',
  Back: 'Back',
  'You are online': 'You are online',
  'You are offline': 'You are offline',
  'Reservation Management': 'Reservation Management',
  Dashboard: 'Dashboard',
  'My Reservations': 'My Reservations',
  'My Account': 'My Account',
  'Favorites Hotels': 'Favorites Hotels',
  'Recent Searches': 'Recent Searches',
  'My Coupons:': 'My Coupons:',
  Status: 'Status',
  created: 'Created',
  initialized: 'Pending',
  confirmed: 'Confirmed',
  completed: 'Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
  error: 'Error',
  rejected: 'Rejected',
  review: 'Pending',
  fraud: 'Pending',
  blocked: 'Pending',
  requested: 'Pending',
  'pending-refund': 'Cancellation Process',
  'pending-cancellation': 'Pending Cancellation',
  'error-cancellation': 'Pending Cancellation',
  'cancelled-with-fees': 'Cancelled',
  frozen: 'Frozen',
  'frozen-with-fees': 'Frozen',
  pending: 'Pending',
  'pending-payment': 'Pending Payment',
  incomplete: 'Pending',
  Type: 'Type',
  flight: 'Flight',
  ticket: 'Ticket',
  car: 'Car Rental',
  package: 'Package',
  Country: 'Country',
  Landmarks: 'Landmarks',
  Restaurants: 'Restaurants',
  Tax: 'Tax',
  VAT: 'VAT',
  'Split Fee': 'Split Fee',
  Markup: 'Markup',
  Valid: 'Valid',
  Expired: 'Expired',
  'Coupon code': 'Coupon code',
  Balance: 'Balance',
  Update: 'Update',
  'the hotel': 'the hotel',
  'the airline': 'the airline',
  'the service provider': 'the service provider',
  'Successfully sent.': 'Successfully sent.',
  'Successfully updated.': 'Successfully updated.',
  'Successfully canceled.': 'Successfully canceled.',
  'The images are for illustration only and may not fully represent the room features you have selected.':
    'The images are for illustration only and may not fully represent the room features you have selected.',
  'The process was successful': 'The process was successful',
  'Your booking has been successfully canceled':
    'Your booking has been successfully canceled',
  'How would you like to receive a refund for this booking?':
    'How would you like to receive a refund for this booking?',
  'Give me a coupon code': 'Give me a coupon code',
  'Hey, you received a coupon': 'Hey, you received a coupon',
  'You already have voucher we will refund it, the code is':
    'You already have voucher we will refund it, the code is',
  'with this amount': 'with this amount',
  'Hey, we have renewed the coupon for you':
    'Hey, we have renewed the coupon for you',
  'Its code': 'Its code',
  'Credit my credit card': 'Credit my credit card',
  "Iֿֿ'll decide later": "Iֿֿ'll decide later",
  'Special Request': 'Special Request',
  'Special requests for this room': 'Special requests for this room',
  'Please write your requests in English. Special requests are not guaranteed - but the hotel will do its best to fulfill your needs.':
    'Please write your requests in English. Special requests are not guaranteed - but the hotel will do its best to fulfill your needs.',
  'City tax': 'City Tax',
  'Mandatory tax': 'Mandatory Tax',
  'mandatory tax': 'Mandatory Tax',
  'mandatory fee': 'Mandatory Tax',
  'resort fee': 'Resort Fee',
  'service charge': 'Service Charge',
  'electricity fee': 'Electricity Fee',
  TaxAndServiceFee: 'Taxes & Fees',
  'tax and service fee': 'Taxes & Fees',
  'Your commission': 'Your commission',
  Included: 'Included',
  'Not Included - Collected by property':
    'Not Included - Collected by property',
  'Have a Coupon?': 'Have a Coupon?',
  'Coupon Code': 'Coupon Code',
  'No vouchers found': 'No vouchers found',
  'Create payment voucher': 'Create payment voucher',
  'Last week': 'Last week',
  'Last month': 'Last month',
  'Between dates': 'Between dates',
  'You have a balance of {amount} to redeem in this reservation. Would you like to get a coupon?':
    'You have a balance of {amount} to redeem in this reservation. Would you like to get a coupon?',
  'Have a payment voucher?': 'Have a payment voucher?',
  'Voucher Code': 'Voucher Code',
  'My Vouchers': 'My Vouchers',
  'Created at': 'Created at',
  'Reservation no.': 'Reservation no.',
  'No voucher redemptions found': 'No voucher redemptions found',
  'Balance to redeem': 'Balance to redeem',
  Amount: 'Amount',
  code: 'Code',
  'My redemptions': 'My redemptions',
  Hide: 'Hide',
  Discount: 'Discount',
  'Payment voucher': 'Payment voucher',
  'Payment voucher issued': 'Payment voucher issued',
  'Payment voucher redeemed': 'Payment voucher redeemed',
  Apply: 'Apply',
  Cash: 'Cash',
  'Bank Transfer': 'Bank Transfer',
  Receipt: 'Receipt',
  'Total Price': 'Total Price',
  'Total Received': 'Total Received',
  'We converted the price to display in':
    'We converted the price to display in',
  'Original price': 'Original price',
  'Reservation Summary': 'Reservation Summary',
  'Agent reference': 'Agent reference',
  'The site is secured by international PCI standards, the most strict standards for purchasing online.':
    'The site is secured by international PCI standards, the most strict standards for purchasing online.',
  '{distance} km': '{distance} km',
  '{distance} m': '{distance} m',
  "What's nearby": "What's nearby",
  'Getting around': 'Getting around',
  'min walk': 'min walk',
  'min drive': 'min drive',
  'Hotel Facilities': 'Hotel Facilities',
  'Filter rooms by': 'Filter rooms by',
  'Show less': 'Show less',
  'Show more': 'Show more',
  'Show all': 'Show all',
  'Remind Me': 'Remind Me',
  'On this date we will remind you to pay':
    'On this date we will remind you to pay',
  "Your booking has been confirmed by the hotel, but hasn't been paid for yet. You're Confirmation number is {id}. We will send you a reminder and a link for payment on {remind_at} to your email {email}.":
    "Your booking has been confirmed by the hotel, but hasn't been paid for yet. You're Confirmation number is {id}. We will send you a reminder and a link for payment on {remind_at} to your email {email}.",
  "Please note! If the payment will not be received by {date} the booking will be cancelled automatically and couldn't be restored.":
    "Please note! If the payment will not be received by {date} the booking will be cancelled automatically and couldn't be restored.",
  "Please note! If the payment will not be received by {date} the booking will be cancelled automatically and couldn't be restored. The reserve cost won't be refunded.":
    "Please note! If the payment will not be received by {date} the booking will be cancelled automatically and couldn't be restored. The reserve cost won't be refunded.",
  'I confirm that the transaction price shown in {currency} is an approximate price converted from an amount of {original_price}. Any payment towards the value of the transaction price will be charged according to the exchange rate at the time of the actual payment.':
    'I confirm that the transaction price shown in {currency} is an approximate price converted from an amount of {original_price}. Any payment towards the value of the transaction price will be charged according to the exchange rate at the time of the actual payment.',
  'The transaction price shown in {currency} is an approximate price converted from an amount of {original_price}. Any payment towards the value of the transaction price will be charged according to the exchange rate at the time of the actual payment.':
    'The transaction price shown in {currency} is an approximate price converted from an amount of {original_price}. Any payment towards the value of the transaction price will be charged according to the exchange rate at the time of the actual payment.',
  "If the reservation will be cancelled, the late payment cost of {payment} won't be refunded.":
    "If the reservation will be cancelled, the late payment cost of {payment} won't be refunded.",
  'Note! The cost of splitting a credit card is {payment} for each additional card.':
    'Note! The cost of splitting a credit card is {payment} for each additional card.',
  'Note! The cost of late payment is {payment}.':
    'Note! The cost of late payment is {payment}.',
  'We are just sending your booking to the hotel and waiting for confirmation. This may take a few minutes. In the next few minutes you will receive an email regarding your booking.':
    'We are just sending your booking to the hotel and waiting for confirmation. This may take a few minutes. In the next few minutes you will receive an email regarding your booking.',
  'We are just sending your booking to {provider} and waiting for confirmation. This may take a few minutes. In the next few minutes you will receive an email regarding your booking.':
    'We are just sending your booking to {provider} and waiting for confirmation. This may take a few minutes. In the next few minutes you will receive an email regarding your booking.',
  "Reservation {number} was not approved. Please enter a new reservation. Please note that we have reserved the amount you paid but didn't charge it. It will be cancelled automatically in a couple of days. You can enter a new reservation. If you want to use the reserve already placed to your card, please contact our customer support using our email reservations@travelor.com with your reservation number.":
    "Reservation {number} was not approved. Please enter a new reservation. Please note that we have reserved the amount you paid but didn't charge it. It will be cancelled automatically in a couple of days. You can enter a new reservation. If you want to use the reserve already placed to your card, please contact our customer support using our email reservations@travelor.com with your reservation number.",
  "Reservation {number} is awating approval. Your reservation is now managed by our customer support team for approval. Please contact us using our email reservations@travelor.com or wait for our team to contact you. Please note that we reserved the amount paid with your credit card. If your reservation wonֿֿ't be completed, the reserve will be cancelled automatically in a couple of days.":
    "Reservation {number} is awating approval. Your reservation is now managed by our customer support team for approval. Please contact us using our email reservations@travelor.com or wait for our team to contact you. Please note that we reserved the amount paid with your credit card. If your reservation wonֿֿ't be completed, the reserve will be cancelled automatically in a couple of days.",
  'Someone has just booked this room before you. Please':
    'Someone has just booked this room before you. Please',
  'return to the home page': 'return to the home page',
  'Return to Hotel Page': 'Return to Hotel Page',
  'Return to {name}': 'Return to {name}',
  "Someone's just booked that room and we can't complete your reservation.":
    "Someone's just booked that room and we can't complete your reservation.",
  'We apologize for the inconvenience': 'We apologize for the inconvenience',
  'Hey, are you still there?': 'Hey, are you still there?',
  "You've been inactive for 30 minutes so your search results have expired.":
    "You've been inactive for 30 minutes so your search results have expired.",
  'Hit refresh to see the latest hotel prices.':
    'Hit refresh to see the latest hotel prices.',
  'and restart your booking process.': 'and restart your booking process.',
  'Payments Received': 'Payments Received',
  'Full Name': 'Full Name',
  'Payment Amount': 'Payment Amount',
  'Balance Due': 'Balance Due',
  'Receipt details': 'Receipt details',
  'Multiple credit cards': 'Multiple credit cards',
  'Single credit card': 'Single credit card',
  'Credit Card Details': 'Credit Card Details',
  'Reservation Number': 'Reservation Number',
  'Cancellation Deadline': 'Cancellation Deadline',
  'Create Date': 'Create Date',
  'Future payment': 'Future payment',
  'Offset from my wallet': 'Offset from my wallet',
  'Select your payment option': 'Select your payment option',
  Customer: 'Customer',
  Book: 'Book',
  Clear: 'Clear',
  'Payment details': 'Payment details',
  'Payment type': 'Payment type',
  'Card number': 'Card number',
  'Payments number': 'Payments number',
  'View invoice': 'View invoice',
  'View your voucher': 'View your voucher',
  'Cancel Booking': 'Cancel Booking',
  'Shere us with your cancel reason': 'Shere us with your cancel reason',
  "I don't want to cancel": "I don't want to cancel",
  'Are you sure you want to cancel this booking?':
    'Are you sure you want to cancel this booking?',
  'It will not be possible to restore the booking':
    'It will not be possible to restore the booking',
  'I have made several bookings for those dates and I want to cancel what is not needed':
    'I have made several bookings for those dates and I want to cancel what is not needed',
  'I found another accommodation': 'I found another accommodation',
  'Personal reasons / trip canceled': 'Personal reasons / trip canceled',
  'Change in the number or needs of the guests':
    'Change in the number or needs of the guests',
  'None of the above options': 'None of the above options',
  'Are you sure you want to book this reservation?':
    'Are you sure you want to book this reservation?',
  'No reservations found': 'No reservations found',
  'More room info': 'More room info',
  'Load More': 'Load More',
  'The ': 'The ',
  'Best Hotel': 'Best Hotel',
  'Best Apartment': 'Best Apartment',
  'Best Hostel': 'Best Hostel',
  'at The Best Price - Guaranteed!': 'at The Best Price - Guaranteed!',
  'at The Best Price!': 'at The Best Price!',
  'Best Price Guaranteed!': 'Best Price Guaranteed!',
  'Travelor - Hotels Worldwide': 'Travelor - Hotels Worldwide',
  'Best price guaranteed, Big Savings booking hotels worldwide, up to 75% off on hotel reservations online.':
    'Best price guaranteed, Big Savings booking hotels worldwide, up to 75% off on hotel reservations online.',
  Login: 'Login',
  Password: 'Password',
  Logout: 'Logout',
  Cancel: 'Cancel',
  Close: 'Close',
  'Forgot your password?': 'Forgot your password?',
  'Are you sure you want to Logout?': 'Are you sure you want to Logout?',
  'Your Choice': 'Your Choice',
  'The best match': 'The best match',
  'Soon...': 'Soon...',
  'Oops...': 'Oops...',
  'Please wait...': 'Please wait...',
  'Connects to a secure server...': 'Connects to a secure server...',
  'Try Again': 'Try Again',
  'An error has occurred': 'An error has occurred',
  'Your Profile': 'Your Profile',
  'Your Details': 'Your Details',
  'Your Reservation': 'Your Reservation',
  'Hotels in Israel': 'Hotels in Israel',
  'Hotels in {destination}': 'Hotels in {destination}',
  'Hotels near {destination}': 'Hotels near {destination}',
  'Compare hotel prices in {destination}':
    'Compare hotel prices in {destination}',
  'Compare hotel prices near {destination}':
    'Compare hotel prices near {destination}',
  'Searching Hotels in {destination}...':
    'Searching Hotels in {destination}...',
  'Searching Hotels near {destination}...':
    'Searching Hotels near {destination}...',
  'Hotels found in {destination}':
    'No hotels found in {destination} | One hotel found in {destination} | {count} Hotels found in {destination}',
  'Hotels found near {destination}':
    'No hotels found near {destination} | One hotel found near {destination} | {count} Hotels found near {destination}',
  '{count} of {total} hotels found in {destination}':
    'No hotels found in {destination} | {count} of one hotel found in {destination} | {count} of {total} hotels found in {destination}',
  '{count} of {total} hotels found near {destination}':
    'No hotels found near {destination} | {count} of one hotel found near {destination} | {count} of {total} hotels found near {destination}',
  'is initialized': 'is in the confirmation process...',
  'is confirmed': 'is confirmed!',
  'is completed': 'is completed!',
  'is cancelled': 'is cancelled!',
  'is rejected': 'is rejected.',
  'is pending-cancellation': 'is pending cancellation...',
  'is pending': 'is awaiting confirmation...',
  'is pending-payment': 'is pending payment.',
  'Reservation #{id} {status}': 'Reservation #{id} {status}',
  'Reservation #{id} to the {hotel} {status}':
    'Reservation #{id} to the {hotel} {status}',
  'Dear customer, Your reservation is confirmed! Reservation voucher and receipt will be sent to you in the next few minutes in 2 different emails. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'Dear customer, Your reservation is confirmed! Reservation voucher and receipt will be sent to you in the next few minutes in 2 different emails. For your comfort, your reservation number for contacting our customer service is <b>{number}</b>. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!',
  'Dear customer, Your reservation is cancelled. Your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com':
    'Dear customer, Your reservation is cancelled. Your reservation number for contacting our customer service is <b>{number}</b>. At any point and from any reason you can contact us with this email reservations@travelor.com',
  'Dear customer, Your reservation is being processed but is not approved yet. Please wait for confirmation email. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'Dear customer, Your reservation is being processed but is not approved yet. Please wait for confirmation email. For your comfort, your reservation number for contacting our customer service is <b>{number}</b>. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!',
  'Dear customer, Your reservation to {destination} is confirmed! Reservation voucher and receipt will be sent to you in the next few minutes in 2 different emails. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'Dear customer, Your reservation to {destination} is confirmed! Reservation voucher and receipt will be sent to you in the next few minutes in 2 different emails. For your comfort, your reservation number for contacting our customer service is <b>{number}</b>. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!',
  'Dear customer, Your reservation to {destination} is cancelled. Your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com':
    'Dear customer, Your reservation to {destination} is cancelled. Your reservation number for contacting our customer service is <b>{number}</b>. At any point and from any reason you can contact us with this email reservations@travelor.com',
  'Dear customer, Your reservation to {destination} is being processed but is not approved yet. Please wait for confirmation email. For your comfort, your reservation number for contacting our customer service is {number}. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!':
    'Dear customer, Your reservation to {destination} is being processed but is not approved yet. Please wait for confirmation email. For your comfort, your reservation number for contacting our customer service is <b>{number}</b>. At any point and from any reason you can contact us with this email reservations@travelor.com Have a fun vacation!',
  Search: 'Search',
  OK: 'OK',
  Destination: 'Destination',
  Rooms: 'Rooms',
  Adults: 'Adults',
  Children: 'Children',
  'Children ages': 'Children ages',
  Room: 'Room',
  'Add Room': 'Add Room',
  Remove: 'Remove',
  'Destination or hotel name...': 'Destination or hotel name...',
  'Select Destination': 'Select Destination',
  'Select Dates': 'Select Dates',
  'Check-in': 'Check-in',
  'Check-out': 'Check-out',
  1: 'first',
  2: 'second',
  3: 'third',
  4: 'fourth',
  'How would you like to pay?': 'How would you like to pay?',
  'How many credit cards will you want to pay?':
    'How many credit cards will you want to pay?',
  'How much would you like to pay on {card} credit card?':
    'How much would you like to pay on {card} credit card?',
  '{count} reservations':
    'No reservations | One reservation | {count} reservations',
  '{count} cards': ' | One credit card | {count} cards',
  '{count} nights': ' | One night | {count} nights',
  '{count} rooms': 'No rooms | One room | {count} rooms',
  '{count} hotels': 'No hotels | One hotel | {count} hotels',
  '{count} reviews': ' | One review | {count} reviews',
  '{count} adults': ' | One adult | {count} adults',
  '{count} children': 'No children | One child | {count} children',
  'Total for {count} nights':
    ' | Total for one night | Total for {count} nights',
  '{distance} m from {destination}': '{distance} m from {destination}',
  '{distance} mi from {destination}': '{distance} mi from {destination}',
  '{distance} km from {destination}': '{distance} km from {destination}',
  'Reservations longer than 30 nights are not possible':
    'Reservations longer than 30 nights are not possible',
  '{count} people are viewing this hotel right now!':
    '{count} people are viewing this hotel right now!',
  'Last reservation for this hotel was made {time}.':
    'Last reservation for this hotel was made {time}.',
  Filters: 'Filters',
  Sort: 'Sort',
  Map: 'Map',
  List: 'List',
  'Clear filters': 'Clear filters',
  'the center': 'the center',
  'Show Filters': 'Show Filters',
  'Hide Filters': 'Hide Filters',
  'Show Results': 'Show Results',
  'Hide Results': 'Hide Results',
  'Show Options': 'Show Options',
  'Hide Options': 'Hide Options',
  'Map View': 'Map View',
  'Show on Map': 'Show on Map',
  'Close Map': 'Close Map',
  'Sort hotels by': 'Sort hotels by',
  'Hotel Name': 'Hotel Name',
  'highest first': 'highest first',
  'lowest first': 'lowest first',
  Popularity: 'Popularity',
  Distance: 'Distance',
  Price: 'Price',
  Stars: 'Stars',
  'Property type': 'Property type',
  apartment: 'Apartment',
  hostel: 'Hostel',
  other: 'Other',
  hotel: 'Hotel',
  Wonderful: 'Wonderful',
  'Very Good': 'Very Good',
  Good: 'Good',
  Pleasant: 'Pleasant',
  'Guest rating': 'Guest rating',
  'Hotel facilities': 'Hotel facilities',
  'Room facilities': 'Room facilities',
  From: 'From',
  'taxes and charges': 'taxes & charges',
  'Useable until {date}': 'Useable until {date}',
  'Includes VAT': 'Includes VAT',
  'VAT not included': 'VAT not included',
  'See Rooms': 'See Rooms',
  'Book Now': 'Book Now',
  'Pay Now': 'Pay Now',
  'Cancellation Policy': 'Cancellation Policy',
  refundable: 'Refundable',
  'fully-refundable': 'Free Cancellation',
  'non-refundable': 'Non Refundable',
  nonrefundable: 'Non Refundable',
  'Refundable until {date}': '<b>Refundable</b> until {date}',
  'Refundable before {date}': '<b>Refundable</b> before {date}',
  'From {date} non refundable': 'From {date} <b>Non Refundable</b>',
  'Free cancellation before {date}': '<b>Free cancellation</b> before {date}',
  'I want to receive copy of voucher to e-mail {email}.':
    'I want to receive copy of voucher to e-mail <b>{email}</b>.',
  'I want to receive the voucher to e-mail {email}.':
    'I want to receive the voucher to e-mail {email}.',
  RO: 'Room Only',
  BB: 'Bed and Breakfast',
  CB: 'Continental Breakfast',
  HB: 'Half Board',
  FB: 'Full Board',
  AI: 'All Inclusive',
  Twin: 'Twin',
  King: 'King',
  Queen: 'Queen',
  Double: 'Double',
  double: 'Double',
  quadruple: 'Quadruple',
  '1 Twin Bed': 'Twin Bed',
  '1 King Bed': 'King Bed',
  '1 Queen Bed': 'Queen Bed',
  '1 Double Bed': 'Double Bed',
  '2 Twin Beds': '2 Twin Beds',
  '2 King Beds': '2 King Beds',
  '2 Queen Beds': '2 Queen Beds',
  '2 Double Beds': '2 Double Beds',
  '3 Twin Beds': '3 Twin Beds',
  '1 King Bed and 1 Twin Bed': 'King Bed and Twin Bed',
  '1 King Bed and 1 Queen Bed': 'King Bed and Queen Bed',
  '1 King Bed and 1 Double Bed': 'King Bed and Double Bed',
  '1 King Bed and 1 Double Sofa Bed': 'King Bed and Double Sofa Bed',
  '1 King Bed or 2 Twin Beds': 'King Bed or 2 Twin Beds',
  '1 King Bed and 2 Twin Bunk Beds': 'King Bed and 2 Twin Bunk Beds',
  '2 Twin Beds or 1 King Bed': '2 Twin Beds or 1 King Bed',
  '2 Double Beds or 1 King Bed': '2 Double Beds or 1 King Bed',
  '2 Queen Beds and 2 Twin Beds': '2 Queen Beds and 2 Twin Beds',
  'Room Size': 'Room Size',
  'Free Wifi': 'Free Wifi',
  'Non Smoking': 'Non Smoking',
  'No rooms matched your filter': 'No rooms matched your filter',
  "Notice! Most hotels don't have rooms for over 4 people. If you are not getting any results, please make a new search choosing 2 rooms (or more).":
    "Notice! Most hotels don't have rooms for over 4 people. If you are not getting any results, please make a new search choosing 2 rooms (or more).",
  'No results matched your search': 'No results matched your search',
  'This offer has expired': 'This offer has expired',
  'Only English': 'Only English',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'E-Mail Address': 'E-Mail Address',
  'Customer E-Mail Address': 'Customer E-Mail Address',
  'Confirm E-Mail Address': 'Confirm E-Mail Address',
  'Confirm Customer E-Mail Address': 'Confirm Customer E-Mail Address',
  'Attention!': 'Attention!',
  'The rate presented is for {country} citizens only.':
    'The rate presented is for {country} citizens only.',
  'Change the rate for {country} citizens':
    'Change the rate for {country} citizens',
  'I am a citizen of {country}': 'I am a citizen of {country}',
  Citizenship: 'Citizenship',
  Prefix: 'Prefix',
  'Phone Number': 'Phone Number',
  'Card Number': 'Card Number',
  'Cancellation fee': 'Cancellation fee',
  'Cannot be more then total price': 'Cannot be more then total price',
  'Add additional commission': 'Add additional commission',
  '{percent}% will be deducted from the added commission.':
    '{percent}% will be deducted from the added commission.',
  '{percent}% will be deducted from the cancellation fee.':
    '{percent}% will be deducted from the cancellation fee.',
  'I want to set cancellation fee': 'I want to set cancellation fee',
  'Please note! It is possible that the accommodation will collect additional charges (city tax, resort fee, etc.) in accordance with its policy which will be paid directly to the accommodation.':
    'Please note! It is possible that the accommodation will collect additional charges (city tax, resort fee, etc.) in accordance with its policy which will be paid directly to the accommodation.',
  'I agree to the': 'I agree to the',
  'remarks & cancellation policy': 'remarks & cancellation policy',
  'Remarks & Cancellation policy': 'Remarks & Cancellation policy',
  'I want to receive promotional offers in the future.':
    'I want to receive promotional offers in the future.',
  'Continue to Payment': 'Continue to Payment',
  'Secure Booking': 'Secure Booking',
  Home: 'Home',
  Company: 'Company',
  About: 'About',
  'lang/about': 'en/about',
  'Contact Us': 'Contact Us',
  'lang/contact': 'en/contact',
  Testimonials: 'Testimonials',
  'lang/testimonials': 'en/testimonials',
  FAQ: 'FAQ',
  'lang/faq': 'en/faq',
  'Terms & Conditions': 'Terms & Conditions',
  'Agent Terms & Conditions': 'Agent Terms & Conditions',
  'lang/terms': 'en/terms-of-use',
  'Privacy & Cookie Statement': 'Privacy & Cookie Statement',
  'lang/privacy': 'en/privacy-policy',
  'Best Price Guaranteed': 'Best Price Guaranteed',
  'lang/best-price-guaranteed': 'en/best-price-guaranteed',
  Services: 'Services',
  Hotels: 'Hotels',
  Packages: 'Packages',
  Tickets: 'Tickets',
  Flights: 'Flights',
  'Car Rentals': 'Car Rentals',
  'Travel Insurance': 'Travel Insurance',
  'Currency Exchange': 'Currency Exchange',
  'Join as an Agent': 'Join as an Agent',
  Continents: 'Continents',
  Places: 'Places',
  Destinations: 'Destinations',
  Asia: 'Asia',
  Africa: 'Africa',
  'North America': 'North America',
  'South America': 'South America',
  Antarctica: 'Antarctica',
  Europe: 'Europe',
  Oceania: 'Oceania',
  Dark: 'Dark',
  Light: 'Light',
  System: 'System',
  Reviews: 'Reviews',
  'Reservations pending payment': 'Reservations pending payment',
  'View receipt': 'View receipt',
  'Send request to hotel': 'Send request to hotel',
  'Edit request to hotel': 'Edit request to hotel',
  'View your HCN': 'View your HCN',
  'Send voucher': 'Send voucher',
  'Enter email address': 'Enter email address',
  Send: 'Send',
  Reference: 'Reference',
  Pay: 'Pay',
  'Enter your request': 'Enter your request',
  Language: 'Language',
  Currency: 'Currency',
  'Price display': 'Price display',
  'Net price (no commission)': 'Net price (no commission)',
  'Gross price (including commission)': 'Gross price (including commission)',
  'Base price': 'Base price',
  'Price includes taxes & charges': 'Price includes taxes & charges',
  'Popular currencies': 'Popular currencies',
  'All currencies': 'All currencies',
  'Great choice of property': 'Great choice of property',
  'Sending a special request to the hotel':
    'Sending a special request to the hotel',
  'Special requests are sent to the hotel and there are no commitments to be fulfilled':
    'Special requests are sent to the hotel and there are no commitments to be fulfilled',
  // 'According to your search, you can not select more than {rooms} rooms': 'According to your search, you can not select more than {rooms} rooms',
  'This offer will expire in {minutes} minutes {seconds} seconds':
    'This offer will expire in {minutes} minutes {seconds} seconds',
  'Please select a reason': 'Please select a reason',
  'Please enter a name': 'Please enter a name',
  'Please enter a first name': 'Please enter a first name',
  'Please enter a last name': 'Please enter a last name',
  'Please enter an email address': 'Please enter an email address',
  'Please enter a valid email address': 'Please enter a valid email address',
  'Please enter a phone': 'Please enter a phone',
  'The email confirmation does not match':
    'The email confirmation does not match',
  'Please enter only English characters':
    'Please enter only English characters',
  'Book now, Pay later': 'Book now, Pay later',
  'Refresh Results': 'Refresh Results',
  'Go To Home Page': 'Go To Home Page',
  'Agent ID': 'Agent ID',
  'NEW!': 'NEW!',
  'Recommended!': 'Recommended!',
  'Customer Details': 'Customer Details',
  'Payer Details': 'Payer Details',
  'Secure Payment': 'Secure Payment',
  'Hotel Details': 'Hotel Details',
  'Rooms and Guests Details': 'Rooms and Guests Details',
  'Of the lead guest in this room': 'Of the lead guest in this room',
  'Confirmation email sent to this address':
    'Confirmation email sent to this address',
  'For updates regarding your reservation':
    'For updates regarding your reservation',
  'Translate to {locale}': 'Translate to {locale}',
  'Translated from {source} by': 'Translated from {source} by',
  'Show source': 'Show source',
  'Tax invoice': 'Tax invoice',
  'Edit Tax invoice': 'Edit Tax invoice',
  'Name on Invoice': 'Name on Invoice',
  'Name on Receipt': 'Name on Receipt',
  'Business name': 'Business name',
  'VAT Number': 'VAT Number',
  'I want to receive tax invoice.': 'I want to receive tax invoice.',
  'A tax invoice will be sent on the check-out day.':
    'A tax invoice will be sent on the check-out day.',
  'A receipt will be sent to this email address':
    'A receipt will be sent to this email address',
  "Travelor's banks details": "Travelor's banks details",
  Leumi: 'Leumi',
  Poalim: 'Poalim',
  'Bank number': 'Bank number',
  'Branch number': 'Branch number',
  'Account number': 'Account number',
  'Account name': 'Account name',
  'V. Travelor LTD': 'V. Travelor LTD',
  'Bank Transfer Details': 'Bank Transfer Details',
  'Date transfer': 'Date transfer',
  'Amount for this reservation': 'Amount for this reservation',
  Name: 'Name',
  "Bank account holder's name": "Bank account holder's name",
  'Which the transfer was made from': 'Which the transfer was made from',
  'Total amount': 'Total amount',
  'The total amount of the transfer': 'The total amount of the transfer',
  'From the total amount': 'Amount for this reservation From the total amount',
  Bank: 'Bank',
  'The bank from which the transfer was received':
    'The bank from which the transfer was received',
  'Receipt type': 'Receipt type',
  'One receipt for all reservations': 'One receipt for all reservations',
  'A separate receipt for each reservation':
    'A separate receipt for each reservation',
  'Travelor Bank': 'Travelor Bank',
  'Transfer type': 'Transfer type',
  Regular: 'Regular',
  RTGS: 'RTGS',
  'Upload transfer confirmation document':
    'Upload transfer confirmation document',
  Remarks: 'Remarks',
  Confirm: 'Confirm',
  en: 'English',
  Sum: 'Sum',
  Value: 'Value',
  'Cancel reservation': 'Cancel reservation',
  'Cancel reservation with 100% cancellation fee':
    'Cancel reservation with 100% cancellation fee',
  'I confirm the cancellation of the reservation with 100% cancellation fees.':
    'I confirm the cancellation of the reservation with 100% cancellation fees.',
  'Please accept': 'Please accept',
  'Reservation {id}': 'Reservation {id}',
  'Love helping your friends book vacations?':
    'Love helping your friends book vacations?',
  "Let's make money from it!": "Let's make money from it!",
  'By clicking on the button I agree to receive occasional emails. We hate spam and we will never give away your details.':
    'By clicking on the button I agree to receive occasional emails. We hate spam and we will never give away your details.',
  'Payment reservation {id}': 'Payment reservation {id}',
  // 'The information and images about the hotels presented on the website are supplied by the hotels and suppliers we are working with. Travelor does not oblige to the credibility and accuracy of the information.': 'The information and images about the hotels presented on the website are supplied by the hotels and suppliers we are working with. Travelor does not oblige to the credibility and accuracy of the information.',
  "I confirm reading, understanding and updating the customer with all the reservation details. Including hotel information, board basis, dates, compositions, room type, cancelation, payment details, room notes, taxes and additional charges that may be charged by the hotel, and I'm fully responsible for this reservation.  If it turns out that the information I gave my customer was missing or incorrect, I understand that the implications (if will be) are my responsibility only.":
    "I confirm reading, understanding and updating the customer with all the reservation details. Including hotel information, board basis, dates, compositions, room type, cancelation, payment details, room notes, taxes and additional charges that may be charged by the hotel, and I'm fully responsible for this reservation.  If it turns out that the information I gave my customer was missing or incorrect, I understand that the implications (if will be) are my responsibility only.",
  'Copyright © {year} {brand}. all rights reserved.':
    'Copyright © {year} {brand}. all rights reserved.',
  'Add to quote': 'Add to quote',
  'Customer information': 'Customer information',
  'Add New Customer': 'Add New Customer',
  'Quote information': 'Quote information',
  'Quote Name': 'Quote Name',
  Probability: 'Probability',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  very_high: 'Very High',
  'Valid until': 'Valid until',
  'Add Comments': 'Add Comments',
  'Comment for internal use': 'Comment for internal use',
  'Comment for customer': 'Comment for customer',
  'Create Quote': 'Create Quote',
  'Add Customer': 'Add Customer',
  'Create Customer': 'Create Customer',
  'Select Customer': 'Select Customer',
  'This field is required': 'This field is required',
  'Success! Your quote is now ready.': 'Success! Your quote is now ready.',
  'Copied!': 'Copied!',
  'Copy link': 'Copy link',
  'View your quote': 'View your quote',
  'Add To Cart': 'Add To Cart',
  'Add to cart': 'Add to cart',
  "Item successfully added to {name}'s cart!":
    "Item successfully added to {name}'s cart!",
  "View {name}'s Cart": "View {name}'s Cart",
  'Customer identification': 'Customer identification',
  directFlight: 'Direct Flight',
  oneStop: 'One Stop',
  twoStops: 'Two Stops',
  'Flight Details': 'Flight Details',
  'Passenger Details': 'Passenger Details',
  'Passenger {index}': 'Passenger {index}',
  'Car Details': 'Car Details',
  'Ticket Details': 'Ticket Details',
  'Package Details': 'Package Details',
  'or similar': 'or similar',
  Pickup: 'Pickup',
  at: 'at',
  '{num} seats': '{num} seats',
  automatic: 'automatic',
  manual: 'manual',
  unknown: 'unknown',
  '{num} large bag': '{num} suitcase',
  '{num} small bag': '{num} trolley',
  'Room {idx}': 'Room {idx}',
  'Room Type': 'Room Type',
  Board: 'Board',
  Guests: 'Guests',
  Babies: 'Infants',
  Seniors: 'Seniors',
  Students: 'Students',
  Youth: 'Youth',
  Outbound: 'Departure',
  Inbound: 'Return',
  Adult: 'Adult',
  Child: 'Child',
  Infant: 'Infant',
  Senior: 'Senior',
  Student: 'Student',
  Date: 'Date',
  Location: 'Location',
  Seats: 'Seats',
  Quantity: 'Quantity',
  'Pick-up': 'Pick-up',
  'Drop-off': 'Drop-off',
  'Passport expiry date': 'Passport expiry date',
  'Passport number': 'Passport number',
  'Date of birth': 'Date of birth',
  Baggage: 'Baggage',
  'flight section': 'Flight route',
  'Rental company': 'Rental company',
  'To select a seat or add baggage press here':
    'To select a seat or add baggage press here',
  'Flight no.': 'Flight no.',
  'Passenger Type': 'Passenger Type',
  'Date Change': 'Date Change',
}
